import React from 'react';
import '../BadgeContainer/BadgeContainer.css';  // Import the CSS file
import ResourceTypeBadge from '../ResourceTypeBadge/ResourceTypeBadge';  
import FileTypeBadge from '../FileTypeBadge/FileTypeBadge';

const BadgeContainer = ({ resourceType, fileType }) => {
  return (
    <div className="badge-container">  {/* Add the class name here */}
        <ResourceTypeBadge resourceType={resourceType} />
        <FileTypeBadge fileType={fileType} />
    </div>
  );
};

export default BadgeContainer;